module.exports = __webpack_public_path__ + "img/tvcontrol_nodata.ba4eedc0.png";